import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

export const notificationRef = { current: null };

export function addToast(message, type = 'info', duration = 3500) {
  if (notificationRef.current) {
    notificationRef.current(message, type, duration);
  }
}

const styles = {
  container: {
    position: 'fixed',
    bottom: '1.5rem',
    left: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    zIndex: 9999,
  },
  toast: {
    padding: '0.75rem 1.25rem',
    borderRadius: '12px',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.875rem',
    fontWeight: 500,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.06)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: '240px',
    maxWidth: '320px',
    border: '1px solid',
    backdropFilter: 'blur(8px)',
    animation: 'slideIn 0.2s ease',
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0,
  },
  success: {
    background: '#F0FAF6',
    color: '#2A7D5F',
    borderColor: '#b6ddd0',
  },
  successDot: { background: '#2A7D5F' },
  error: {
    background: '#FEF2F1',
    color: '#C0392B',
    borderColor: '#f1b8b3',
  },
  errorDot: { background: '#C0392B' },
  info: {
    background: '#FFFFFF',
    color: '#1A1714',
    borderColor: '#E8E4DF',
  },
  infoDot: { background: '#E8649A' },
};

const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes slideIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;
document.head.appendChild(styleSheet);

function Notifications() {
  const [toasts, setToasts] = useState([]);

  notificationRef.current = (message, type, duration) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  };

  useEffect(() => {
    return () => { notificationRef.current = null; };
  }, []);

  const getDotStyle = (type) => {
    if (type === 'success') return styles.successDot;
    if (type === 'error') return styles.errorDot;
    return styles.infoDot;
  };

  return ReactDOM.createPortal(
    <div style={styles.container}>
      {toasts.map(t => (
        <div
          key={t.id}
          style={{ ...styles.toast, ...styles[t.type] }}
          onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
        >
          <span style={{ ...styles.dot, ...getDotStyle(t.type) }} />
          {t.message}
        </div>
      ))}
    </div>,
    document.body
  );
}

export default Notifications;